import { FavoriteKinds, FavoriteV5Short } from '../../models/favorite';

export const FAVORITES_ACTIONS: {
  ADD: 'ADD';
  DELETE: 'DELETE';
} = {
  ADD: 'ADD',
  DELETE: 'DELETE',
};

export type UpdateFavoritesSignature = (
  itemId: number | string,
  kind: keyof typeof FavoriteKinds
) => Promise<void>;

export function getFavoriteKind(item: FavoriteV5Short) {
  if (item.content_type === 'events.event') {
    return FavoriteKinds.event;
  }
  if (item.content_type === 'specializations.person') {
    return FavoriteKinds.person;
  }
  if (item.content_type === 'events.place') {
    return FavoriteKinds.place;
  }
  if (item.content_type === 'blog.material') {
    return FavoriteKinds.material;
  }
  return null;
}

export interface FavoriteModel {
  id: string;
  favId: string;
  kind: string;
}
